import { useQuery } from '@tanstack/react-query';
import { queryKeys, requestCCApi } from 'src/utils';

export type BulkReplaceRequestNamesByAssemblyIdsFilter = {
  assembly_ids: number[];
  statuses: string[];
  from_component_id?: number;
};

export const useGetBulkReplaceRequestNamesByAssemblyIds = (
  filters: BulkReplaceRequestNamesByAssemblyIdsFilter,
  enabled: boolean = true,
) => {
  const queryKeysFilters: string[] = [];

  queryKeysFilters.push(`assembly_ids=${filters.assembly_ids.join('|')}`);
  queryKeysFilters.push(`statuses=${filters.statuses.join('|')}`);

  if (filters.from_component_id) {
    queryKeysFilters.push(`from_component_id=${filters.from_component_id}`);
  }

  return useQuery({
    queryKey:
      queryKeys.bulkReplaceRequestNamesByAssemblyIds.all(queryKeysFilters),
    queryFn: () => fetchBulkReplaceRequestNamesByAssemblyIdsFilter(filters),
    staleTime: Infinity,
    enabled,
  });
};

const fetchBulkReplaceRequestNamesByAssemblyIdsFilter = async (
  filters: BulkReplaceRequestNamesByAssemblyIdsFilter,
) => {
  const response = await requestCCApi({
    url: `/bulkReplaceRequestNamesByAssemblyIds`,
    method: 'POST',
    data: { data: filters },
  });

  return response.data;
};
